<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir CNPJ"
                @click.stop="confirmarExcluirCnpj()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        outraEmpresa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirCnpj() {
            this.$swal({
                title: 'CNPJ',
                html: `Confirma a exclusão do CNPJ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirCnpj()
                }
            })
        },

        excluirCnpj() {
            this.$emit('excluirOutraEmpresa', this.outraEmpresa)
        }
    },
}
</script>
